
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    date () {
      return this.post?.date ? this.getDate(this.post.date) : ``;
    },
    category () {
      return this.getCategory(this.post);
    },
  },
};
